import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { FilesAmountStyled, SectionInfoStyled, TitleStyled, TotalFilesLabelStyled } from './styles';

interface TableInfoBarProps extends ICustomizableElement {
  title: string;
  totalFiles?: number;
}

const TableInfoBar: React.FC<TableInfoBarProps> = ({ title, totalFiles, className }) => {
  return (
    <SectionInfoStyled className={className}>
      <TitleStyled>{title}</TitleStyled>
      {totalFiles !== undefined && (
        <TotalFilesLabelStyled>
          Total Files: <FilesAmountStyled>{totalFiles}</FilesAmountStyled>
        </TotalFilesLabelStyled>
      )}
    </SectionInfoStyled>
  );
};

export default TableInfoBar;
